import { ProductPriceAndEarningInfo } from '../product-price-and-earning-info/ProductPriceAndEarningInfo';
import { markdownToRawMarkup } from '../../utils/html-utils';
import { InformationList } from '../../project/project-edit/products/InformationList';
import { ImageSlider } from '../image-slider/ImageSlider';
import { getBlockComponentForContent } from '../../utils/cms-utils';
import { useEffect, useRef, useState } from 'react';
import styles from './product-category-modal-info.module.less';

export const ProductCategoryModalInfo = ({ product, options = {} }) => {
    const { showOwnerExtraInfo } = options;

    const [showScrollIcon, setShowScrollIcon] = useState(true);
    const [isScrollable, setIsScrollable] = useState(false);
    const [images, setImages] = useState([]);

    const contentRef = useRef(null);

    const onScroll = () => {
        setShowScrollIcon(false);
    };

    useEffect(() => {
        const node = contentRef.current;
        if (!node) {
            return null;
        }

        const hasScrollableContent = node.scrollHeight > node.clientHeight;
        const overflowYStyle = getComputedStyle(node).overflowY;
        const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

        setIsScrollable(hasScrollableContent && !isOverflowHidden);

        node.addEventListener('scroll', onScroll);

        return () => {
            node.removeEventListener('scroll', onScroll);
        };
    }, []);

    useEffect(() => {
        setImages(product.images);
    }, [product]);

    return (
        <>
            <div className={styles.mainContentWrapper} ref={contentRef}>
                {images.length > 0 && <ImageSlider imageUrls={images} />}
                <div className={styles.contentWrapper}>
                    {product.pricingData?.salePrice && (
                        <ProductPriceAndEarningInfo product={product} options={options} />
                    )}
                    {product.longDescription && (
                        <div
                            className={styles.longDescription}
                            dangerouslySetInnerHTML={markdownToRawMarkup(product.longDescription)}
                            tabIndex={0}
                        />
                    )}
                    {product.ownerExtraInfo && showOwnerExtraInfo && (
                        <div dangerouslySetInnerHTML={markdownToRawMarkup(product.ownerExtraInfo)} tabIndex={1} />
                    )}
                    {product.tables?.length > 0 &&
                        product.tables?.map((table) => getBlockComponentForContent({ data: table }))}
                    <InformationList className={styles.informationList} />
                </div>
            </div>
            {isScrollable && (
                <div className={styles.scrollHelperParent}>
                    <span className={[styles.scrollHelper, showScrollIcon ? '' : styles.hideScrollIcon].join(' ')}>
                        <i className={[`fa-solid fa-arrow-down`, styles.scrollHelperIcon].join(' ')} />
                    </span>
                </div>
            )}
        </>
    );
};
